import { MatDialogConfig } from '@angular/material/dialog';

export const MEDIA_VIEWER_CONFIG: MatDialogConfig = {
  panelClass: 'no-padding',
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  maxHeight: '100%',
  autoFocus: false,
};

export const MEDIA_VIEWER_MIME_TYPES: Record<string, string> = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  webp: 'image/webp',
  bmp: 'image/bmp',
  svg: 'image/svg+xml',
  pdf: 'application/pdf',
};
